import { inject, Injectable } from '@angular/core';
import { StepResolverStrategy } from './step-resolver.strategy';
import { Observable, of } from 'rxjs';
import { Step } from '../../types';
import { CourseStepDefinitionService } from '../step-definition';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class CourseStepResolverService implements StepResolverStrategy {
  private readonly courseStepDefinitionService = inject(CourseStepDefinitionService);

  resolve(activeFlow: Flow): Observable<Step> {
    return of(this.courseStepDefinitionService.getStepDefinition(activeFlow));
  }
}
